import OkTableConfigType from '@/@bya3/components/tables/ok-table/OkTableConfigType'
import { API_URL } from '@/constants/config'
import store from '@/store'

const N8nPostsHistoryTableConfig: OkTableConfigType = {
  mode: 'remote',
  url: `${API_URL}/n8n-posts-history`,
  rowsPath: 'data',
  rowClickable: true,
  attachPageId: false,
  actionFirst: true,
  actions: [
    {
      label: 'forms.delete',
      eventName: 'delete',
      icon: 'Trash2Icon',
      hide: () => !store.getters['auth/isAdmin'],
    },
  ],
  columns: [
    {
      label: 'fields.id',
      field: 'id',
    },
    {
      label: 'n8n.n8n_page_id',
      field: 'n8n_page_id',
    },
    {
      label: 'page.name',
      field: 'n8n_page.page.page_name',
    },
    {
      label: 'n8n.post_id',
      field: 'post_id',
    },
    {
      label: 'n8n.reply_id',
      field: 'reply_id',
    },
    {
      label: 'n8n.topic',
      field: 'topic',
    },
    {
      label: 'n8n.status',
      field: 'status',
    },
    {
      label: 'n8n.error',
      field: 'error',
    },
    {
      label: 'fields.created_at',
      field: 'created_at',
    },
  ],
  paginationOptions: {
    enabled: true,
  },
  sortOptions: {
    enabled: false,
  },
  filters: [
    {
      label: 'page.name',
      query: 'page_id',
      colLength: 4,
      type: 'autocomplete',
    },
    {
      label: 'n8n.n8n_page_id',
      query: 'n8n_page_id',
      colLength: 4,
      type: 'text',
    },
    {
      label: 'n8n.status',
      query: 'status',
      colLength: 4,
      type: 'select',
      multiple: false,
      options: [
        { text: 'n8n.pending', value: 'pending' },
        { text: 'n8n.completed', value: 'completed' },
        { text: 'n8n.failed', value: 'failed' },
      ],
      optionsLabel: { keyLabel: 'text', valueLabel: 'value', translate: true },
    },
  ],
}

export default N8nPostsHistoryTableConfig
